import { createElement, Fragment } from 'react';

const InfoGlyph = ({
  glyph
}) => {
  switch (glyph) {
    case 'no-places':
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
        id: "shadow"
      }, /*#__PURE__*/createElement("feGaussianBlur", {
        stdDeviation: "6"
      }))), /*#__PURE__*/createElement("polygon", {
        filter: "url(#shadow)",
        points: "35.7,69.6 97.9,52.7 160.3,69.6 222.7,52.7 222.7,194.3 160.3,211.2 98,194.5 35.7,211.3",
        opacity: "0.3"
      }), /*#__PURE__*/createElement("g", {
        fill: "#fff"
      }, /*#__PURE__*/createElement("path", {
        d: "M160.3,211.2c20.8-5.6,41.6-11.2,62.4-16.9V52.7c-20.8,5.6-41.6,11.2-62.4,16.9 C160.3,116.8,160.3,164,160.3,211.2z"
      }), /*#__PURE__*/createElement("polygon", {
        points: "98,194.4 160.3,211.2 160.3,69.6 97.9,52.7",
        opacity: "0.8"
      }), /*#__PURE__*/createElement("path", {
        d: "M97.9,52.7c-20.7,5.6-41.5,11.2-62.2,16.9v141.7c20.8-5.6,41.6-11.2,62.3-16.8C98,147.2,97.9,99.9,97.9,52.7 z"
      })), /*#__PURE__*/createElement("polygon", {
        points: "175.6,31 177.3,39.1 184.5,43.2 176.4,44.9 172.3,52.1 170.6,44 163.4,39.9 171.5,38.2",
        opacity: "0.5"
      }), /*#__PURE__*/createElement("polygon", {
        points: "53.5,202.3 58.4,204.5 63.2,202.3 61,207.2 63.2,212 58.4,209.9 53.5,212 55.7,207.2",
        opacity: "0.5"
      }), /*#__PURE__*/createElement("polygon", {
        points: "49.7,40.2 52.9,43.2 56.7,41 55.7,45.3 59.4,47.5 55.3,48.8 55.2,53.2 52,50.2 48.2,52.3 49.2,48.1 45.4,45.8 49.6,44.6",
        opacity: "0.5"
      }), /*#__PURE__*/createElement("polygon", {
        points: "189.2,147.8 192.4,150.8 196.2,148.6 195.2,152.9 198.9,155.1 194.8,156.4 194.7,160.8 191.5,157.8 187.7,159.9 188.7,155.6 184.9,153.4 189.1,152.1",
        opacity: "0.5"
      }), /*#__PURE__*/createElement("polygon", {
        points: "240.9,130.9 243,132.8 245.4,131.4 244.8,134.1 247.2,135.5 244.5,136.3 244.5,139.1 242.4,137.2 240,138.6 240.6,135.9 238.2,134.4 240.9,133.6",
        opacity: "0.5"
      }), /*#__PURE__*/createElement("polygon", {
        points: "12,119 14.1,120.9 16.5,119.5 15.8,122.2 18.2,123.6 15.6,124.4 15.5,127.2 13.5,125.3 11.1,126.7 11.7,124 9.3,122.5 12,121.7",
        opacity: "0.5"
      }));
    case 'no-content':
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
        id: "shadow"
      }, /*#__PURE__*/createElement("feGaussianBlur", {
        stdDeviation: "6"
      }))), /*#__PURE__*/createElement("path", {
        filter: "url(#shadow)",
        d: "M191.1,82.7H64.9L33,117.8v93c0,3.3,2.7,6,6,6h178.2c3.2,0,5.9-2.6,5.9-5.9v-93.1L191.1,82.7z M127.6,166.5\tc-8.2,0-14.8-6.6-14.8-14.8s6.6-14.8,14.8-14.8c8.2,0,14.8,6.6,14.8,14.8S135.8,166.5,127.6,166.5z",
        opacity: "0.3"
      }), /*#__PURE__*/createElement("rect", {
        x: "64.9",
        y: "82.7",
        opacity: "0.5",
        fill: "#FFFFFF",
        width: "126.1",
        height: "35.4"
      }), /*#__PURE__*/createElement("polygon", {
        opacity: "0.6",
        fill: "#FFFFFF",
        points: "223,117.8 33,117.8 64.9,82.7 191.1,82.7"
      }), /*#__PURE__*/createElement("path", {
        fill: "#FFFFFF",
        d: "M33,117.8v93c0,3.3,2.7,6,6,6h178.2c3.2,0,5.9-2.6,5.9-5.9v-93.1H33z M127.6,166.5c-8.2,0-14.8-6.6-14.8-14.8 c0-8.2,6.6-14.8,14.8-14.8s14.8,6.6,14.8,14.8C142.4,159.9,135.8,166.5,127.6,166.5z"
      }), /*#__PURE__*/createElement("g", {
        opacity: "0.2"
      }, /*#__PURE__*/createElement("path", {
        d: "M105.4,61.5c-1.3-2.2-2.3-3.8-3.2-4.9l1.6-1.2c1,1.3,2,2.9,3.3,5.1L105.4,61.5z"
      }), /*#__PURE__*/createElement("path", {
        d: "M134,98.6l-1.9-0.7c0.8-2.3,1.7-4.5,2.6-6.6c-1.2-0.5-2.4-1.1-3.5-1.7l0.9-1.8c1.1,0.6,2.2,1.1,3.4,1.6 c0.5-1.2,1-2.3,1.6-3.4l1.8,0.9c-0.5,1.1-1,2.2-1.5,3.3c2.1,0.8,4.2,1.4,6.4,2l-0.5,1.9c-2.3-0.5-4.6-1.2-6.7-2.1 C135.7,94.2,134.8,96.3,134,98.6z M157.5,95.7c-0.5,0-0.9,0-1.4,0l0-2c1.2,0,2.5,0,3.8,0c3.2-0.1,6.1-0.4,8.7-0.8l0.3,2 c-2.7,0.4-5.7,0.7-9,0.8C159.1,95.7,158.3,95.7,157.5,95.7z M181.3,90.8l-1.1-1.7c2.9-1.9,4.4-4.2,4.4-6.9c0-0.9-0.2-1.8-0.5-2.7 l1.9-0.6c0.4,1.1,0.6,2.3,0.6,3.4C186.6,85.6,184.8,88.6,181.3,90.8z M120.7,82.1c-3-2.8-5.8-6-8.4-9.7l1.6-1.2 c2.6,3.7,5.3,6.8,8.2,9.4L120.7,82.1z M145.1,76.1l-1.6-1.2c3-4.2,6.1-7.3,9.2-9.2l1,1.7C150.9,69.2,147.9,72.1,145.1,76.1z M176.6,70.3c-3.4-2.4-7.4-4-11.2-4.7l0.3-2c4.1,0.7,8.4,2.5,12,5L176.6,70.3z"
      }), /*#__PURE__*/createElement("path", {
        d: "M128.6,116.4l-1.9-0.4c0-0.1,0.5-2.3,1.5-5.8l1.9,0.5C129.1,114.2,128.6,116.4,128.6,116.4z"
      })), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
        opacity: "0.2"
      }, /*#__PURE__*/createElement("path", {
        d: "M94.4,37.7c-0.9-2.9-3.3-3.4-5.4-1.2L69.8,57.8c-2,2.2-1.3,4.6,1.7,5.2l28,6.1c2.9,0.6,4.6-1.2,3.7-4.1 L94.4,37.7z"
      })), /*#__PURE__*/createElement("g", {
        opacity: "0.2"
      }, /*#__PURE__*/createElement("path", {
        d: "M91.6,35c-2.9,0.9-3.4,3.3-1.2,5.4l21.2,19.3c2.2,2,4.6,1.3,5.2-1.7l6.1-28c0.6-2.9-1.2-4.6-4.1-3.7L91.6,35z"
      })), /*#__PURE__*/createElement("path", {
        opacity: "0.5",
        d: "M94.4,37.7c-0.6-2-2-2.8-3.5-2.4c0-5.7,0-5.8,2-7.1c0.2-0.1,0.3-0.5,0.2-0.7c-0.1-0.2-0.5-0.3-0.7-0.2 c-2.5,1.6-2.5,1.9-2.5,8.1c-5.7-2.6-5.9-2.7-8.4-1.1c-0.2,0.1-0.3,0.5-0.1,0.7c0.1,0.2,0.5,0.3,0.7,0.1c2.1-1.3,2.1-1.3,7.4,1.1 c-0.8,1.1-0.5,2.6,0.9,3.9l6.9,6.2L94.4,37.7z"
      })));
    case 'wait':
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
        id: "shadow"
      }, /*#__PURE__*/createElement("feGaussianBlur", {
        stdDeviation: "6"
      }))), /*#__PURE__*/createElement("g", {
        filter: "url(#shadow)",
        opacity: "0.3"
      }, /*#__PURE__*/createElement("path", {
        d: "M96.1,45.8C54.3,61.5,29.8,104.4,37.8,148s46,75.5,90.4,75.5s82.3-31.8,90.4-75.5s-16.5-86.9-58.2-102.3 c-3.1-1.1-6.1,0.4-7.3,3.4c-1.1,3.1,0.4,6.1,3.4,7.3c36.4,13.8,57.8,51.3,50.9,89.6c-6.9,38.3-40.2,66.3-79.3,66.3 s-72.4-28-79.3-66.3s14.6-76.2,50.9-89.6c3.1-1.1,4.6-4.2,3.4-7.3C102.2,46.1,99.1,44.6,96.1,45.8"
      }), /*#__PURE__*/createElement("path", {
        d: "M83.4,137.3c-3.1,0-5.7-2.7-5.7-5.7s2.7-5.7,5.7-5.7h33.7c0.4,0,0.4,0,0.4-0.4c1.1-1.9,2.7-3.4,4.6-4.6 c0.4,0,0.4-0.4,0.4-0.4V72.2c0-3.1,2.7-5.7,5.7-5.7s5.7,2.7,5.7,5.7v48.6c0,0.4,0,0.4,0.4,0.4c6.9,3.8,8.4,13.4,2.7,19.2 c-5.7,5.7-15.3,4.2-19.2-2.7c0-0.4-0.4-0.4-0.4-0.4L83.4,137.3"
      })), /*#__PURE__*/createElement("path", {
        fill: "#FFFFFF",
        d: "M96.1,45.8C54.3,61.5,29.8,104.4,37.8,148s46,75.5,90.4,75.5s82.3-31.8,90.4-75.5s-16.5-86.9-58.2-102.3 c-3.1-1.1-6.1,0.4-7.3,3.4c-1.1,3.1,0.4,6.1,3.4,7.3c36.4,13.8,57.8,51.3,50.9,89.6c-6.9,38.3-40.2,66.3-79.3,66.3 s-72.4-28-79.3-66.3s14.6-76.2,50.9-89.6c3.1-1.1,4.6-4.2,3.4-7.3C102.2,46.1,99.1,44.6,96.1,45.8"
      }), /*#__PURE__*/createElement("path", {
        fill: "#FFFFFF",
        d: "M83.4,137.3c-3.1,0-5.7-2.7-5.7-5.7s2.7-5.7,5.7-5.7h33.7c0.4,0,0.4,0,0.4-0.4c1.1-1.9,2.7-3.4,4.6-4.6 c0.4,0,0.4-0.4,0.4-0.4V72.2c0-3.1,2.7-5.7,5.7-5.7s5.7,2.7,5.7,5.7v48.6c0,0.4,0,0.4,0.4,0.4c6.9,3.8,8.4,13.4,2.7,19.2 c-5.7,5.7-15.3,4.2-19.2-2.7c0-0.4-0.4-0.4-0.4-0.4L83.4,137.3"
      }), /*#__PURE__*/createElement("path", {
        opacity: "0.2",
        d: "M129,33.5c-6.9-0.4-12.3,4.6-12.6,11.5c-0.4,6.5,4.6,12.3,11.5,12.6c6.5,0.4,12.3-4.6,12.6-11.5\tC140.9,39.6,135.5,33.9,129,33.5"
      }));
    case 'no-power':
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
        id: "shadow"
      }, /*#__PURE__*/createElement("feGaussianBlur", {
        stdDeviation: "6"
      }))), /*#__PURE__*/createElement("path", {
        filter: "url(#shadow)",
        d: "M38.4,168c-3-8.6-4.8-17.5-5.3-26.7c-0.1-1.7-0.1-3.4-0.1-5.1c0-1.6,0-3.2,0.1-4.9l9.3,0.5c-0.1,1.5-0.1,2.9-0.1,4.4\tc0,1.5,0,3.1,0.1,4.6c0.4,8.3,2,16.4,4.8,24.1L38.4,168z M217.6,167.9l-8.8-3.1c3.2-9.1,4.9-18.7,4.9-28.5c0-1.5,0-3.1-0.1-4.6\tl0-0.3l9.3-0.5l0,0.3c0.1,1.7,0.1,3.4,0.1,5.1C223,147.2,221.2,157.8,217.6,167.9z M44.5,116.7l-9-2.1c2.9-12.2,8-23.5,15.4-33.7\tl7.5,5.4C51.8,95.5,47.1,105.7,44.5,116.7z M211.4,116.3c-2.6-11-7.3-21.2-14-30.4l7.5-5.5c7.4,10.2,12.6,21.5,15.5,33.7\tL211.4,116.3z M68.4,74.7L61.9,68c9-8.7,19.5-15.5,31.1-20.1l3.4,8.6C86,60.7,76.5,66.8,68.4,74.7z M187.3,74.4\tc-8.2-7.8-17.7-13.9-28.2-18l3.4-8.6c11.6,4.6,22.1,11.3,31.2,20L187.3,74.4z M111.1,52.2l-1.8-9.1c4.5-0.9,9.1-1.5,13.7-1.7\tc7.9-0.4,15.7,0.1,23.3,1.6l-1.8,9.1c-6.9-1.4-13.9-1.9-21.1-1.5C119.3,50.9,115.1,51.4,111.1,52.2z",
        opacity: "0.3"
      }), /*#__PURE__*/createElement("path", {
        fill: "#FFFFFF",
        d: "M38.4,168c-3-8.6-4.8-17.5-5.3-26.7c-0.1-1.7-0.1-3.4-0.1-5.1c0-1.6,0-3.2,0.1-4.9l9.3,0.5\tc-0.1,1.5-0.1,2.9-0.1,4.4c0,1.5,0,3.1,0.1,4.6c0.4,8.3,2,16.4,4.8,24.1L38.4,168z M217.6,167.9l-8.8-3.1c3.2-9.1,4.9-18.7,4.9-28.5\tc0-1.5,0-3.1-0.1-4.6l0-0.3l9.3-0.5l0,0.3c0.1,1.7,0.1,3.4,0.1,5.1C223,147.2,221.2,157.8,217.6,167.9z M44.5,116.7l-9-2.1\tc2.9-12.2,8-23.5,15.4-33.7l7.5,5.4C51.8,95.5,47.1,105.7,44.5,116.7z M211.4,116.3c-2.6-11-7.3-21.2-14-30.4l7.5-5.5\tc7.4,10.2,12.6,21.5,15.5,33.7L211.4,116.3z M68.4,74.7L61.9,68c9-8.7,19.5-15.5,31.1-20.1l3.4,8.6C86,60.7,76.5,66.8,68.4,74.7z M187.3,74.4c-8.2-7.8-17.7-13.9-28.2-18l3.4-8.6c11.6,4.6,22.1,11.3,31.2,20L187.3,74.4z M111.1,52.2l-1.8-9.1\tc4.5-0.9,9.1-1.5,13.7-1.7c7.9-0.4,15.7,0.1,23.3,1.6l-1.8,9.1c-6.9-1.4-13.9-1.9-21.1-1.5C119.3,50.9,115.1,51.4,111.1,52.2z"
      }), /*#__PURE__*/createElement("path", {
        opacity: "0.5",
        d: "M141.1,154.3l-8-61.1c-0.5-4-6.2-4-6.8,0l-8,61.1c-3.9,3.3-6.3,8.1-6.3,13.6c0,9.8,7.9,17.8,17.8,17.8\ts17.8-7.9,17.8-17.8C147.4,162.5,145,157.6,141.1,154.3z M129.7,177.9c-5.5,0-9.9-4.4-9.9-9.9s4.4-9.9,9.9-9.9\tc5.5,0,9.9,4.4,9.9,9.9S135.2,177.9,129.7,177.9z"
      }));
    case 'no-graph':
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
        id: "shadow"
      }, /*#__PURE__*/createElement("feGaussianBlur", {
        stdDeviation: "6"
      }))), /*#__PURE__*/createElement("path", {
        d: "M214,202.8H53.5V42.3c0-2.8-2.3-5-5-5c-2.8,0-5,2.3-5,5v160.5H34c-2.8,0-5,2.3-5,5c0,2.8,2.3,5,5,5h9.3v9.3 c0,2.8,2.3,5,5,5c2.8,0,5-2.3,5-5v-9.3H214c2.8,0,5-2.3,5-5C219,205.1,216.7,202.8,214,202.8z",
        filter: "url(#shadow)",
        opacity: "0.3"
      }), /*#__PURE__*/createElement("path", {
        fill: "#FFFFFF",
        d: "M214,202.8H53.5V42.3c0-2.8-2.3-5-5-5c-2.8,0-5,2.3-5,5v160.5H34c-2.8,0-5,2.3-5,5c0,2.8,2.3,5,5,5h9.3v9.3 c0,2.8,2.3,5,5,5c2.8,0,5-2.3,5-5v-9.3H214c2.8,0,5-2.3,5-5C219,205.1,216.7,202.8,214,202.8z"
      }), /*#__PURE__*/createElement("g", {
        opacity: "0.2"
      }, /*#__PURE__*/createElement("path", {
        d: "M125.9,130.3l-0.2-2.7c-0.2-5.3,1.5-10.7,6.2-16.4c3.3-4,6-7.4,6-10.8c0-3.6-2.4-6.2-7.5-6.3 c-3.5,0-7.6,1.1-10.4,3.1l-3.4-11.4c3.8-2.2,9.9-4.3,17.4-4.3c13.7,0,20,7.6,20,16.2c0,8-5,13.2-9,17.6c-3.8,4.3-5.4,8.3-5.3,13 v1.9H125.9z M132.3,154.2c-5.5,0-9.3-4.1-9.3-9.5c0-5.6,3.9-9.5,9.3-9.5c5.6,0,9.3,3.9,9.4,9.5c0,5.4-3.6,9.5-9.3,9.5H132.3z"
      })));
    default:
      return null;
  }
};

export default InfoGlyph;
